import type { CharacterGridSpec } from "@/character/grid";
import type { ShadowDefinition } from "@/shadow/types";

export type ShadowGameArt = {
  shadowSpritesheetUrl: string;
  shadowSpritesheetGrid: CharacterGridSpec;
  shadowIdleTextureUrl: string;
};

export function shadowToGameArt(shadow: ShadowDefinition | null | undefined): ShadowGameArt | undefined {
  if (!shadow?.spritesheetDataUrl) return undefined;
  return {
    shadowSpritesheetUrl: shadow.spritesheetDataUrl,
    shadowSpritesheetGrid: shadow.grid,
    shadowIdleTextureUrl: shadow.actions.idle,
  };
}
